import { render, staticRenderFns } from "./JobEditTabInformation.vue?vue&type=template&id=2bc06c18"
import script from "./JobEditTabInformation.vue?vue&type=script&lang=js"
export * from "./JobEditTabInformation.vue?vue&type=script&lang=js"
import style0 from "./JobEditTabInformation.vue?vue&type=style&index=0&id=2bc06c18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports